import { get_axios_instance, api_variables, errorHandler } from '@/apis/variables.js';

var axios_instance = get_axios_instance(api_variables.SERVICE_ITDECLARATIONS);
var axios_instance2 = get_axios_instance(api_variables.SERVICE_DOWNLOAD_API);
const _pk_name = "id";

const state = {
    data: {},
    LTA: {},
    TR: {},
    IR: {},
    DS: {},
    CEA: {},
    HFA: {},
    RA: {},
    PD: {},
    FNM: {},
    BE: {},
    BP: {},
    VM: {},
    dependentData: {},
    isFetching: false,
    isSaving: false,
    isDeleting: false,
};

const mutations = {
    set: (state, payload) => {
        state.data = payload;
    },

    add: (state, payload) => {
        state.data.push(payload);
    },

    updateById: (state, payload) => {
        for (let i = 0; i < state.data.length; i++) {
            if (state.data[i][_pk_name] === payload.id) {
                state.data.splice(i, 1, payload);
            }
        }
    },

    removeById: (state, payload) => {
        for (let i = 0; i < state.data.length; i++) {
            if (state.data[i][_pk_name] == payload) {
                state.data.splice(i, 1);
            }
        }
    },
    setLTA: (state, payload) => {
        state.LTA[payload.id] = payload;
    },
    setTR: (state, payload) => {
        state.TR[payload.id] = payload;
    },
    setIR: (state, payload) => {
        state.IR[payload.id] = payload;
    },
    setDS: (state, payload) => {
        state.DS[payload.id] = payload;
    },
    setCEA: (state, payload) => {
        state.CEA[payload.id] = payload;
    },
    setHFA: (state, payload) => {
        state.HFA[payload.id] = payload;
    },
    setRA: (state, payload) => {
        state.RA[payload.id] = payload;
    },
    setPD: (state, payload) => {
        state.PD[payload.id] = payload;
    },
    setFNM: (state, payload) => {
        state.FNM[payload.id] = payload;
    },
    setBE: (state, payload) => {
        state.BE[payload.id] = payload;
    },
    setDependent: (state, payload) => {
        state.dependentData[payload.id] = payload;
    },
    setBP: (state, payload) => {
        state.BP[payload.id] = payload;
    },
    setVM: (state, payload) => {
        state.VM[payload.id] = payload;
    },
    setFetching: (state, payload) => {
        state.isFetching = payload;
    },

    setSaving: (state, payload) => {
        state.isSaving = payload;
    },

    setDeleting: (state, payload) => {
        state.isDeleting = payload;
    }
}

const actions = {
    async fetchAll({ commit }, payload) {
        try {
            commit("setFetching", true);
            let res = await axios_instance.get(`/`, {
                params: {
                    org_id: payload
                }
            });
            commit("setFetching", false);
            if (res.status == 200) {
                commit("set", res.data.rows);
            }
            return res;
        } catch (error) {
            throw errorHandler(err.response);
        }
    },

    async fetchITDeclaration({ commit }, payload) {
        try {
            commit("setFetching", true);
            let res = await axios_instance.get(``, {
                params: {
                    le_id: payload.le_id,
                    employee_id: payload.emp_id,
                    financial_year: payload.fy
                }
            });
            commit("setFetching", false);
            if (res.status == 200) {
                commit("set", res.data.payload);
            }
            return res;
        } catch (error) {
            throw errorHandler(err.response);
        }
    },

    async create({ commit }, payload) {
        try {
            commit("setSaving", true);
            let res = await axios_instance.post(``, payload);
            commit("setSaving", false);
            return res;
        } catch (error) {
            throw errorHandler(err.response);
        }
    },

    async update({ commit }, payload) {
        try {
            commit("setSaving", true);
            let res = await axios_instance.put(`/`, payload);
            commit("setSaving", false);
            return res;
        } catch (error) {
            throw errorHandler(err.response);
        }
    },

    async delete({ commit }, payload) {
        try {
            commit("setDeleting", true);
            let res = await axios_instance.delete(`/${payload.id}`);
            commit("setDeleting", false);
            return res;
        } catch (error) {
            throw errorHandler(err.response);
        }
    },
    // To save locally
    async saveLTA({ commit }, payload) {
        try {
            commit('setLTA', payload);
        } catch (error) {
            throw errorHandler(err.response);
        }
    },
    async saveTR({ commit }, payload) {
        try {
            commit('setTR', payload);
        } catch (error) {
            throw errorHandler(err.response);
        }
    },
    async saveIR({ commit }, payload) {
        try {
            commit('setIR', payload);
        } catch (error) {
            throw errorHandler(err.response);
        }
    },
    async saveDS({ commit }, payload) {
        try {
            commit('setDS', payload);
        } catch (error) {
            throw errorHandler(err.response);
        }
    },
    async saveCEA({ commit }, payload) {
        try {
            commit('setCEA', payload);
        } catch (error) {
            throw errorHandler(err.response);
        }
    },
    async saveHFA({ commit }, payload) {
        try {
            commit('setHFA', payload);
        } catch (error) {
            throw errorHandler(err.response);
        }
    },
    async saveRA({ commit }, payload) {
        try {
            commit('setRA', payload);
        } catch (error) {
            throw errorHandler(err.response);
        }
    },
    async savePD({ commit }, payload) {
        try {
            commit('setPD', payload);
        } catch (error) {
            throw errorHandler(err.response);
        }
    },
    async saveFNM({ commit }, payload) {
        try {
            commit('setFNM', payload);
        } catch (error) {
            throw errorHandler(err.response);
        }
    },
    async saveBE({ commit }, payload) {
        try {
            commit('setBE', payload);
        } catch (error) {
            throw errorHandler(err.response);
        }
    },
    async saveBP({ commit }, payload) {
        try {
            commit('setBP', payload);
        } catch (error) {
            throw errorHandler(err.response);
        }
    },
    async saveVM({ commit }, payload) {
        try {
            commit('setVM', payload);
        } catch (error) {
            throw errorHandler(err.response);
        }
    },
    async saveDependentData({ commit }, payload) {
        try {
            commit('setDependent', payload);
        } catch (error) {
            throw errorHandler(err.response);
        }
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}